export default "__VITE_ASSET__$HtuxyXG__"